export enum HotjarTheme {
  DEFAULT = 'default',
  NEXT = 'next',
  HIGHLIGHT = 'highlight',
}

const getTheme = (): HotjarTheme => {
  if (global.localStorage) {
    switch (global.localStorage.getItem('hotjarTheme')) {
      case 'default':
        return HotjarTheme.DEFAULT;
      case 'next':
        return HotjarTheme.NEXT;
      case 'highlight':
        return HotjarTheme.HIGHLIGHT;
      default:
        return HotjarTheme.NEXT;
    }
  }
  return HotjarTheme.NEXT;
};

export const hotjarTheme = getTheme();
